module.exports = __webpack_public_path__ + "img/ghbourges_cover_cador.dd7be360.jpg";